import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import userIcon from "../../images/icons/user.svg";
import vodoLogo from "../../images/logo/vodo_logo.svg";
import aquastrongLogo from "../../images/logo/aquastrong_logo.svg";
import useMobile from "../../hooks/useMobile";
import { getCurrencyRate } from "../../api/currency";
import { useEffect, useState } from "react";
import Login from "./Login";
import menuIcon from "../../images/icons/burger_menu.svg";
import closeIcon from "../../images/icons/close.svg";
import { useAuth } from "../../contexts/AuthContext";

const Header = ({ handleModal }) => {
  const { isAuth, user, logout, handleLoginSuccess } = useAuth();
  const isTablet = useMobile(1024);
  const isMobile = useMobile(675);

  const [isActive, setIsActive] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const [currancyRate, setCurrencyRate] = useState(null);
  const [lastDate, setLastDate] = useState(null);

  const currentPath = useLocation().pathname;

  const onLoginSuccess = (response) => {
    handleLoginSuccess(response);
    handleModal(false, null);
  };

  const openLoginHandler = () => {
    handleModal(true, <Login onLoginSuccess={onLoginSuccess} />);
  };

  const handleLogout = () => {
    logout();
  };

  const clickMenuHandler = (value) => {
    setIsActive(value);
    if (!hasInteracted) {
      setHasInteracted(true);
    }
  };

  // Прячем скролл бар с задержкой при открытии мобильного меню
  useEffect(() => {
    let timer;
    if (isTablet) {
      if (isActive) {
        timer = setTimeout(() => {
          document.body.style.overflow = "hidden";
          document.body.style.paddingRight = "12px";
        }, 130); // Задержка 0.3 секунды
      } else {
        document.body.style.overflow = "unset";
        document.body.style.paddingRight = "0";
      }
    } else {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "0";
    }

    // Гарантируем, что скроллбар вернется и таймер будет очищен
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "0";
    };
  }, [isActive, isTablet]);

  useEffect(() => {
    if (!isActive) {
      setHasInteracted(false);
    }
  }, [isTablet, isActive]);

  useEffect(() => {
    const checkCurrencyRate = async () => {
      try {
        const data = {
          date: null,
          limit: 1,
        };

        const response = await getCurrencyRate(data);

        if (response.count && response.count > 0) {
          const lastRate = response.result.reduce((latest, current) => {
            if (current.date > latest.date) {
              return current;
            }
            return latest;
          });

          setLastDate(
            new Date(lastRate.date).toLocaleDateString("ru-RU", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }),
          );

          setCurrencyRate(lastRate.currency);
        }
      } catch (error) {
        // console.error("Error updating currency rate: ", error);
      }
    };

    checkCurrencyRate();
  }, []);

  const mobileMenuHiddenStyles =
    isTablet && !isActive && !hasInteracted
      ? {
          visibility: "hidden",
          opacity: 0,
          transition: "none",
          pointerEvents: "none",
        }
      : {};

  return (
    <header className="header shadow">
      {isTablet &&
        !isMobile &&
        !isActive &&
        lastDate !== null &&
        currancyRate !== null && (
          <div className="currancy-rate">
            <span>
              Внутренний курс CNY на {lastDate} — {currancyRate} руб.
            </span>
          </div>
        )}

      {isTablet && !isActive && (
        <img
          className="menu-icon"
          src={menuIcon}
          alt="open menu"
          onClick={() => clickMenuHandler(true)}
        />
      )}
      <div
        className={`header-content ${
          isTablet && isActive && hasInteracted ? "is-active" : ""
        }`}
        style={mobileMenuHiddenStyles}
      >
        {isTablet && isActive && (
          <div className="mobile-top flex-row flex-between w-100">
            <div className="login-button flex-row flex-between gap-2x">
              <img src={userIcon} alt="user icon" />
              {isAuth ? (
                <>
                  <span className="user-email">{user?.email}</span>
                  <span onClick={handleLogout} className="logout-link">
                    Выход
                  </span>
                </>
              ) : (
                <span onClick={() => openLoginHandler()}>Вход</span>
              )}
            </div>
            <img
              className="menu-icon"
              src={closeIcon}
              alt="close menu"
              onClick={() => clickMenuHandler(false)}
            />
          </div>
        )}

        <div className="currancy page-width">
          <div
            className={`header-top w-100 flex-row ${
              lastDate !== null && currancyRate !== null
                ? "flex-between"
                : "flex-end"
            }  ${!isTablet ? "border-bottom" : ""}`}
          >
            {lastDate !== null && currancyRate !== null && (
              <div className="currancy-rate">
                <span>
                  Внутренний курс CNY на {lastDate} — {currancyRate} руб.
                </span>
              </div>
            )}
            {!isTablet && (
              <div className="login-button flex-row flex-between gap-2x">
                <img src={userIcon} alt="user icon" />
                {isAuth ? (
                  <>
                    <span className="user-email">{user?.email}</span>
                    <span onClick={handleLogout} className="logout-link">
                      Выход
                    </span>
                  </>
                ) : (
                  <span onClick={() => openLoginHandler()}>Вход</span>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="navigation page-width">
          <div className="header-bottom">
            <div className="aquastrong-logo">
              <Link to="/" onClick={() => clickMenuHandler(false)}>
                <img
                  className="aquastrong-image"
                  src={aquastrongLogo}
                  alt="aquastrong"
                />
              </Link>
            </div>
            <nav className="header-nav">
              <ul className="nav-list">
                <li className="nav-item">
                  <Link
                    to="/about"
                    className={currentPath.startsWith("/about") ? "active" : ""}
                    onClick={() => clickMenuHandler(false)}
                  >
                    О бренде
                  </Link>
                </li>
                {/* Временно скрываем продукты */}
                {/* <li className="nav-item">
                  <Link
                    to="/products"
                    className={
                      currentPath.startsWith("/products") ? "active" : ""
                    }
                    onClick={() => clickMenuHandler(false)}
                  >
                    Продукты
                  </Link>
                </li> */}
                <li className="nav-item">
                  <Link
                    to="/selection"
                    className={
                      currentPath.startsWith("/selection") ? "active" : ""
                    }
                    onClick={() => clickMenuHandler(false)}
                  >
                    Программа подбора
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/documents"
                    className={
                      currentPath.startsWith("/documents") ? "active" : ""
                    }
                    onClick={() => clickMenuHandler(false)}
                  >
                    Документация
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/balances"
                    className={
                      currentPath.startsWith("/balances") ? "active" : ""
                    }
                    onClick={() => clickMenuHandler(false)}
                  >
                    Складские остатки
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/contacts"
                    className={
                      currentPath.startsWith("/contacts") ? "active" : ""
                    }
                    onClick={() => clickMenuHandler(false)}
                  >
                    Контакты
                  </Link>
                </li>
              </ul>
            </nav>
            <div
              className="vodokomfort-logo"
              onClick={() => clickMenuHandler(false)}
            >
              <a
                href="https://vodokomfort.ru/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="vodokomfort-image"
                  src={vodoLogo}
                  alt="vodokomfort"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
